import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';

import { Subscription } from 'rxjs';

import { LessonService } from '../exercise/shared/lesson.service';
import { LessonModel } from '@generativ/much-smarter-models';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';
import { SafeUrlPipe } from '../../../shared/pipes/safe-url.pipe';

@Component({
    selector: 'app-lesson-introduction',
    templateUrl: './lesson-introduction.component.html',
    styleUrls: ['./lesson-introduction.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, SpinnerComponent, SafeUrlPipe]
})
export class LessonIntroductionComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  vimeoUrl: string;
  lesson: LessonModel;

  constructor(private route: ActivatedRoute,
              private lessonService: LessonService
  ) {
  }

  ngOnInit() {
    this.subscriptions.add(this.route.params.subscribe((params) => {
      if (params['lessonId']) {
        this.subscriptions.add(this.lessonService.getLesson(params['lessonId'])
          .subscribe(
            (lesson) => {
              this.lesson = lesson;
            // TODO: Check Vimeo embed process and update this accordingly
            this.vimeoUrl = 'https://player.vimeo.com/video/';
          }));
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
